import { MatDialogConfig } from "@angular/material/dialog";
import { MOBILE_SLIDE_IN_DIALOG } from "@bitwarden/web-vault/app/models/constants/global.constants";

/** Must match the `max-width: 768px` block for `.mobile-slide-in-dialog` in material-ui.scss. */
export const MOBILE_SLIDE_IN_BREAKPOINT = "(max-width: 768px)";

/** Must match the slide-out keyframe's duration (`--duration-normal`) in material-ui.scss. */
export const MOBILE_SLIDE_OUT_DURATION = "200ms";

/**
 * Spread into the config of a dialog that fills the screen on mobile but is not a
 * RIGHT_PANEL_CONFIG slide-out, in place of its `panelClass`. On mobile the dialog then slides
 * in from the right like the slide-outs do; desktop keeps its centred look.
 *
 * The exit time is picked when the dialog opens. Material's 75ms default would remove the dialog
 * before the 200ms slide-out finishes, and 200ms on desktop would keep the dialog after its own
 * 75ms fade. A dialog opened on desktop and then resized to mobile width loses the end of its
 * slide-out.
 */
export function mobileSlideInConfig(
  panelClass: string,
): Pick<MatDialogConfig, "panelClass" | "exitAnimationDuration"> {
  const config = { panelClass: [panelClass, MOBILE_SLIDE_IN_DIALOG] };
  return isMobileSlideInViewport()
    ? { ...config, exitAnimationDuration: MOBILE_SLIDE_OUT_DURATION }
    : config;
}

/** `matchMedia` isn't available in every runtime (SSR/tests), so default to `false` (desktop). */
function isMobileSlideInViewport(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(MOBILE_SLIDE_IN_BREAKPOINT).matches;
}
